import apiClient from 'src/utils/apiClient';

import type { AssociateProfile, AssociateProfilePlacementsResponse } from './types';

class AssociateProfileService {
  public async getAssociateProfile(alias: string, siteId: number) {
    if (!alias) {
      throw new Error('Alias is required');
    }
    if (!siteId) {
      throw new Error('Site ID is required');
    }
    return await apiClient.get<AssociateProfile>(`/associateProfile/${alias}/sites/${siteId}`);
  }

  public async getAssociateProfilePlacements(alias: string, siteId: number) {
    if (!alias) {
      throw new Error('Alias is required');
    }
    if (!siteId) {
      throw new Error('Site ID is required');
    }
    return await apiClient.get<AssociateProfilePlacementsResponse>(
      `/associateProfile/${alias}/sites/${siteId}/placements`,
    );
  }
}

export default new AssociateProfileService();
